import { FunctionComponent } from 'react';
import { IonItem, IonLabel, IonList, IonSelect, IonSelectOption } from '@ionic/react';
import { EquipmentCharacteristicsPresenter } from '../presenters/equipment-characteristics.presenter';
import { useTranslation } from 'react-i18next';

interface EquipmentCharacteristicsProps {
  equipmentCharacteristics: EquipmentCharacteristicsPresenter;
  onSelectValue: (newValue: string, label: string, type: 'LINE' | 'COLUMN') => void;
}

export const EquipmentCharacteristics: FunctionComponent<EquipmentCharacteristicsProps> =
  ({ equipmentCharacteristics, onSelectValue }) => {

    const { t } = useTranslation();

    return (
      <IonList lines="full" inset role="list">
        <IonItem role="listitem">
          <IonLabel style={ { opacity: 1 } } position={ 'fixed' } slot="start" className={ 'ion-text-wrap' }>
            { t(equipmentCharacteristics.label) } /{ equipmentCharacteristics.line.label }
          </IonLabel>
          <div style={ {
            border: '1px solid gray',
            borderRadius: 5,
            margin: '7px 0',
            flex: 1,
            paddingLeft: 3,
            paddingRight: 10
          } }>
            { <IonSelect
              interface="action-sheet"
              interfaceOptions={ {
                header: equipmentCharacteristics.line.label
              } }
              value={ equipmentCharacteristics.line.initialValue }
              onIonChange={ (e) => {
                onSelectValue(e.detail.value, equipmentCharacteristics.line.values.filter(value => value.number === e.detail.value)[0].name, 'LINE');
              } }
              style={ { maxWidth: '100%' } }
            >
              { equipmentCharacteristics.line.values.map((value) =>
                <IonSelectOption
                  key={ value.number }
                  value={ value.number }
                >
                  { value.number } - { value.name }

                </IonSelectOption>
              ) }

            </IonSelect>
            }
          </div>
        </IonItem>
        <IonItem role="listitem">
          <IonLabel style={ { opacity: 1 } } position={ 'fixed' } slot="start" className={ 'ion-text-wrap' }>
            { t(equipmentCharacteristics.label) } / { equipmentCharacteristics.column.label }
          </IonLabel>
          <div style={ {
            border: '1px solid gray',
            borderRadius: 5,
            margin: '7px 0',
            flex: 1,
            paddingLeft: 3,
            paddingRight: 10
          } }>
            { <IonSelect
              interface="action-sheet"
              interfaceOptions={ {
                header: equipmentCharacteristics.column.label
              } }
              value={ equipmentCharacteristics.column.initialValue }
              onIonChange={ (e) => onSelectValue(e.detail.value, equipmentCharacteristics.column.values.filter(value => value.number === e.detail.value)[0].name, 'COLUMN') }
              style={ { maxWidth: '100%' } }
            >
              { equipmentCharacteristics.column.values.map((value) =>
                <IonSelectOption
                  key={ value.number }
                  value={ value.number }>
                  { value.number } - { value.name }
                </IonSelectOption>
              )
              }
            </IonSelect>
            }
          </div>
        </IonItem>
      </IonList>
    );
  };
